<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16">
    <loyalty-allocations-and-conversion-thresholds-tabs
      :selected-tab="selectedTab"
      @set-selected-tab="setTabSelection"
    />

    <transition-group
      name="fade-down-only-in"
      tag="div"
    >
      <loyalty-challenges
        v-if="selectedTab === 'CHALLENGES'"
        key="challenges"
      />

      <loyalty-allocations
        v-show="selectedTab === 'REWARDS'"
        key="rewards"
      />

      <loyalty-conversion-thresholds
        v-if="isMultiTieredLoyaltyProgram && selectedTab === 'REWARDS_STORE'"
        key="offers"
        @set-selected-tab="setTabSelection"
      />
    </transition-group>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import LoyaltyAllocationsAndConversionThresholdsTabs from './loyalty-allocations-and-conversion-thresholds-tabs/index.vue';
  import LoyaltyAllocations from './loyalty-allocations/index.vue';
  import LoyaltyConversionThresholds from './loyalty-conversion-thresholds/index.vue';
  import LoyaltyChallenges from './loyalty-challenges/index.vue';


  export default {
    name: 'LoyaltyRewardsAndOffers',

    components: {
      LoyaltyAllocationsAndConversionThresholdsTabs,
      LoyaltyAllocations,
      LoyaltyConversionThresholds,
      LoyaltyChallenges
    },

    data() {
      return {
        selectedTab: 'REWARDS'
      };
    },

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('offers', ['loyalty', 'offers']),

      isMultiTieredLoyaltyProgram() {
        return this.loyalty.isMultiTiered;
      },

      hasChallenges() {
        return this.loyalty.challengeLedgers && this.loyalty.challengeLedgers.length > 0;
      }
    },

    created() {
      if (this.hasChallenges) {
        // Challenges always comes first when available
        this.selectedTab = 'CHALLENGES';
      }
    },

    methods: {
      setTabSelection(tabName) {
        this.selectedTab = tabName;
      }
    }
  };
</script>
